import { render, staticRenderFns } from "./ClosurePeriodSettingCreateEditModal.vue?vue&type=template&id=6bb703b4&scoped=true&"
import script from "./ClosurePeriodSettingCreateEditModal.vue?vue&type=script&lang=ts&"
export * from "./ClosurePeriodSettingCreateEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./ClosurePeriodSettingCreateEditModal.vue?vue&type=style&index=0&id=6bb703b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb703b4",
  null
  
)

export default component.exports